import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import styles from './testOverview.scss';
import { t } from '../../services/i18nService';
import sessionReader from '../../store/readHelpers/SessionReader';
import navigationService from '../../services/NavigationService';
import exitButtonSelector from '../../selectors/exitButton/ExitButtonSelector';

const ExitTestButtonComponent = React.memo(({ disabled, label, showButtonForNonLockdown }) => {
    const userHasLockdown = sessionReader.userHasLockDown();
    if (!showButtonForNonLockdown && !userHasLockdown) {
        return null;
    }

    return (
        <button className={`${styles.button} btn`} disabled={disabled} onClick={navigationService.exitTest}>
            {t(label || 'general.exit')}
        </button>
    );
});

ExitTestButtonComponent.propTypes = {
    disabled: PropTypes.bool,
    label: PropTypes.string,
    showButtonForNonLockdown: PropTypes.bool,
};


const mapStateToProps = (state, ownProps) => exitButtonSelector.selectExitButtonProps(state, ownProps);
const ExitTestButton = connect(mapStateToProps)(ExitTestButtonComponent);
export default ExitTestButton;
